import React from "react";

export default function DigitalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M0.404008 0C7.02205 0 12.3934 5.37616 12.3934 12.0001C12.3934 12.5392 11.2083 12.5392 11.2083 12.0001C11.2083 5.82289 6.57572 1.18614 0.404008 1.18614C-0.134669 1.18614 -0.134669 0 0.404008 0Z"
        fill="#231F20"
      />
      <path
        d="M0.404008 2.12598C5.85235 2.12598 10.2695 6.56246 10.2695 12.0156C10.2695 12.5548 9.08442 12.5548 9.08442 12.0156C9.08442 7.00919 5.40602 3.31212 0.404008 3.31212C-0.134669 3.31212 -0.134669 2.12598 0.404008 2.12598Z"
        fill="#231F20"
      />
      <path
        d="M0.403266 4.26733C4.68191 4.26733 8.14484 7.73334 8.14484 12.0158C8.14484 12.5549 6.95975 12.5549 6.95975 12.0158C6.95975 8.18006 4.23558 5.45348 0.418657 5.45348C-0.120021 5.45348 -0.120021 4.26733 0.418657 4.26733H0.403266Z"
        fill="#231F20"
      />
      <path
        d="M3.15857 7.7176L1.83496 8.25675L0.32666 6.71631L2.08121 6.88576L3.15857 7.7176Z"
        fill="#231F20"
      />
      <path
        d="M4.7736 9.36597L4.14258 10.5983L5.71244 12.2158L5.58931 10.4443L4.7736 9.36597Z"
        fill="#231F20"
      />
      <path
        d="M1.84973 8.53442L0.156738 12.2161L3.86592 10.5986L1.84973 8.53442Z"
        fill="#231F20"
      />
      <path
        d="M1.69539 8.39552L0.140919 6.79346L0.0639648 11.954L1.69539 8.39552Z"
        fill="#231F20"
      />
      <path
        d="M4.005 10.7522L0.418945 12.3235C1.60404 12.3235 4.6822 12.3389 5.55947 12.3389L4.005 10.7522Z"
        fill="#231F20"
      />
      <path
        d="M4.62011 9.21204L3.2965 7.85645L1.98828 8.3956L4.00448 10.4598L4.62011 9.21204Z"
        fill="#231F20"
      />
    </svg>
  );
}
